(function () {
  function estado() {
    var el = document.querySelector('[data-ck-estado]');
    return el ? el.getAttribute('data-ck-estado') : null;
  }

function pintar() {
    var e = estado();
    document.body.classList.remove('ck-cart--mixto', 'ck-cart--express', 'ck-cart--agendado', 'ck-cart--programado');
    if (e && e !== 'vacio') document.body.classList.add('ck-cart--' + e);
    if (e === 'mixto' || e === 'agendado') document.body.classList.add('ck-cart--programado');
  }

  document.addEventListener('DOMContentLoaded', pintar);
  new MutationObserver(pintar).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('.cart__checkout-button, [name="checkout"]');
    if (!btn) return;
        var slots = document.getElementById('ck-slots');
    if (slots && !slots.querySelector('input[name="ck_slot"]:checked')) {
      e.preventDefault();
      e.stopPropagation();
      slots.classList.add('ck-slots--error');
      slots.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    e.preventDefault();
    e.stopPropagation();
    try {
      var res = await fetch('/cart', { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      var doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      var el = doc.querySelector('[data-ck-estado]');
      if (el && el.getAttribute('data-ck-estado') !== estado()) {
        window.location.reload();
        return;
      }
    } catch (err) { /* si falla, dejamos continuar */ }

        var cpInput = document.getElementById('ck-cp-input');
    var cpVal = cpInput ? (cpInput.value || '').replace(/\D/g, '') : '';
    if (cpVal.length === 5) {
      window.location.href = '/checkout?checkout[shipping_address][zip]=' + cpVal +
        '&checkout[shipping_address][country]=Mexico';
      return;
    }

    var form = btn.closest('form');
    if (form) { form.submit(); } else { window.location.href = '/checkout'; }
  }, true);
  var TOKEN_EXPRESS = 48404083802333;

  document.addEventListener('change', function (e) {
    var r = e.target;
    if (!r.matches || !r.matches('input[name="ck_slot"]')) return;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          ck_tipo_entrega: r.dataset.tipo,
          ck_fecha: r.dataset.fecha,
          ck_hora_inicio: r.dataset.hora,
          ck_slot: r.value
        }
      })
    });

    var cont = document.getElementById('ck-slots');
    if (cont) cont.classList.remove('ck-slots--error');

    var esExpress = r.dataset.tipo === 'express';

    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (carrito) {
        var linea = carrito.items.filter(function (it) {
          return it.variant_id === TOKEN_EXPRESS;
        })[0];

        if (esExpress && !linea) {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: TOKEN_EXPRESS, quantity: 1 })
          }).then(function (res) {
            if (!res.ok) { console.error('CK: no se pudo agregar el interruptor', res.status); }
            return res;
          });
        }
        if (!esExpress && linea) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: linea.key, quantity: 0 })
          });
        }
        return null;
      })
      .then(function (res) { if (res) window.location.reload(); });
  });

  function abrirDia(dia) {
    document.querySelectorAll('.ck-tab').forEach(function (t) {
      t.setAttribute('aria-selected', t.dataset.dia === dia ? 'true' : 'false');
    });
    document.querySelectorAll('.ck-panel').forEach(function (p) {
      p.hidden = p.dataset.dia !== dia;
    });
  }

  function initTabs() {
    var tabs = document.querySelectorAll('.ck-tab');
    if (!tabs.length) return;
    var elegido = document.querySelector('.ck-panel input:checked');
    abrirDia(elegido ? elegido.dataset.fecha : tabs[0].dataset.dia);
  }

  document.addEventListener('DOMContentLoaded', initTabs);
  new MutationObserver(function () {
    if (!document.querySelector('.ck-tab[aria-selected="true"]')) initTabs();
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('click', function (e) {
    var tab = e.target.closest('.ck-tab');
    if (tab) abrirDia(tab.dataset.dia);
  });
    function cpAplica(cp, lista) {
    if (!cp || !lista) return false;
    return lista.split(',').some(function (p) {
      p = p.trim();
      if (!p) return false;
      if (p.slice(-1) === '*') return cp.indexOf(p.slice(0, -1)) === 0;
      return p === cp;
    });
  }

  function pintarCP(estado, texto) {
    var msg = document.getElementById('ck-cp-msg');
    document.body.classList.remove('ck-cp-pendiente', 'ck-cp-fuera');
    if (estado !== 'ok') document.body.classList.add('ck-cp-' + estado);
    if (!msg) return;
    msg.textContent = texto || '';
    msg.className = 'ck-cp__msg' + (estado === 'ok' ? ' ck-cp__msg--ok' : estado === 'fuera' ? ' ck-cp__msg--no' : '');
  }

  function validarCP(guardar) {
    var caja = document.getElementById('ck-cp');
    var input = document.getElementById('ck-cp-input');
    if (!caja || !input) return;

    var cp = (input.value || '').replace(/\D/g, '');

    if (cp.length !== 5) {
      pintarCP('pendiente', cp.length ? 'El código postal debe tener 5 dígitos.' : '');
      return;
    }

    if (cpAplica(cp, caja.dataset.lista)) {
      pintarCP('ok', 'Tu zona califica para entrega en 1 hora.');
    } else {
      pintarCP('fuera', 'Aún no llegamos a tu zona en 1 hora, pero sí podemos entregarte de forma programada.');
      var exp = document.querySelector('input[name="ck_slot"][data-tipo="express"]');
      if (exp && exp.checked) {
        exp.checked = false;
        var primero = document.querySelector('.ck-panel input[name="ck_slot"]');
        if (primero) { primero.checked = true; primero.dispatchEvent(new Event('change', { bubbles: true })); }
      }
    }

    if (guardar) {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { ck_cp: cp } })
      });
    }
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('#ck-cp-btn')) validarCP(true);
  });

  document.addEventListener('blur', function (e) {
    if (e.target.id === 'ck-cp-input') validarCP(true);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.target.id === 'ck-cp-input' && e.key === 'Enter') {
      e.preventDefault();
      validarCP(true);
    }
  });

  document.addEventListener('DOMContentLoaded', function () { validarCP(false); });
    document.addEventListener('DOMContentLoaded', function () {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var soloToken = c.items.length === 1 && c.items[0].variant_id === TOKEN_EXPRESS;
        if (!soloToken) return;
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: c.items[0].key, quantity: 0 })
        }).then(function () { window.location.reload(); });
      });
  });
    document.addEventListener('DOMContentLoaded', function () {
    var haySlots = document.getElementById('ck-slots');
    var hayExpress = document.querySelector('input[name="ck_slot"][data-tipo="express"]');
    if (!haySlots || hayExpress) return;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var linea = c.items.filter(function (it) {
          return it.variant_id === TOKEN_EXPRESS;
        })[0];
        if (!linea) return null;
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: linea.key, quantity: 0 })
        }).then(function () { window.location.reload(); });
      });
  });
})();